//===================================
// Tabs
//===================================

const Tabs = (ele) => {
  let activeTab = ele.querySelector('.is-active');

  const init = () => {
    const tabs = ele.querySelectorAll('.tab');

    tabs.forEach(tab => {
      tab.addEventListener('click', onClick);
    });
  }

  const onClick = (e) => {
    e.preventDefault();

    const tab = e.target.closest('.tab');
    tab.classList.add('is-active');
    
    activeTab && activeTab.classList.remove('is-active');
    activeTab = tab;
  }

  init();
}

document.addEventListener('DOMContentLoaded', () => {
  const eles = document.querySelectorAll('.tabs');

  eles.forEach(ele => {
    Tabs(ele);
  });
});
